import { render } from "./projectsComponent.vue?vue&type=template&id=042965db&scoped=true"
import script from "./projectsComponent.vue?vue&type=script&lang=js"
export * from "./projectsComponent.vue?vue&type=script&lang=js"

import "./projectsComponent.vue?vue&type=style&index=0&id=042965db&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042965db"]])

export default __exports__